import { WarningIcon } from 'app/agriculture/icons';
import './error_widget.scss';
import { ReactNode } from 'react';

export function ErrorWidget({ errorMessage, id }: { errorMessage?: ReactNode; id?: string }) {
    return (
        <span id={id ?? 'error-message'} className="ErrorWidget">
            <WarningIcon className="ErrorWidget__icon" />
            {errorMessage}
        </span>
    );
}
